import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { CardTitle } from '@/components/ui/card';
    import { columns } from '@/tables/columns/employee-optionals';
    import { Head } from '@inertiajs/vue3';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import DataTable from '@/components/datatable/DataTable.vue';
    import PageCard from '@/components/PageCard.vue';
    import QueryKey from '@/enums/QueryKey';
    import type { BreadcrumbItem } from '@/types';
    import Permission from '@/enums/Permission';
    import { usePermissions } from '@/composables/usePermissions';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeOptionals',
  setup(__props) {

    const { hasPermission } = usePermissions();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'dashboards.payroll',
        },
        {
            title: 'employees-optionals.page_header',
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.EMPLOYEE_OPTIONALS],
        queryFn: getEmployeeOptionals,
    });

    async function getEmployeeOptionals() {
        const { data } = await axios.get(route('v2.salary.employees-optionals.table'));
        return data.data;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('employees-optionals.page_header')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, { breadcrumbs: breadcrumbs }, {
      default: _withCtx(() => [
        (_unref(hasPermission)(_unref(Permission).SALARY_COMPANY_VIEW))
          ? (_openBlock(), _createBlock(PageCard, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(DataTable, {
                  "table-key": _unref(QueryKey).EMPLOYEE_OPTIONALS,
                  columns: _unref(columns),
                  data: _unref(data),
                  loading: _unref(isPending),
                  "default-sorting": [
                    {
                        id: 'name',
                        desc: false,
                    },
                ]
                }, {
                  title: _withCtx(() => [
                    _createVNode(_unref(CardTitle), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('employees-optionals.page_header')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["table-key", "columns", "data", "loading"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})